import React from 'react';
import { Grid, Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import { getProducts } from '../utils/products';

const MarbleCategories = () => {
  const products = getProducts();

  return (
    <Box sx={{ py: 3 }}>
      <Typography variant="h4" component="h2" gutterBottom align="center">
        Our Premium Collections
      </Typography>
      <Typography variant="subtitle1" gutterBottom align="center" color="textSecondary" sx={{ mb: 4 }}>
        Explore our extensive range of premium marbles, granites, and quartz
      </Typography>
      
      <Grid container spacing={3}>
        {/* All Product Images */}
        {products.map((product) => (
          <Grid item key={product.id} xs={6} sm={4} md={3} lg={2}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6
                }
              }}
            >
              <CardMedia
                component="img"
                height="250"
                image={product.productImage}
                alt={product.name}
                sx={{ objectFit: 'cover' }}
                onError={(e: any) => {
                  console.error('Image failed to load:', product.productImage);
                  e.target.style.display = 'none';
                }}
              />
              <CardContent sx={{ flexGrow: 1, p: 1.5 }}>
                <Typography variant="body1" align="center" sx={{ fontWeight: 600 }}>
                  {product.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MarbleCategories; 